(() => {
  'use strict';
  if (customElements.get('statement-collection')) return;
  const C = window.StatementCore;
  const makeCanvas = (w, h) => Object.assign(document.createElement('canvas'), { width: w, height: h });
  const image = src => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('image_error'));
    img.src = src;
  });
  const blob = canvas => new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('export_error')), 'image/png'));
  class StatementCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.$ = selector => this.querySelector(selector);
      this.$$ = selector => [...this.querySelectorAll(selector)];
      this.t = JSON.parse(this.$('[data-statement-strings]').textContent);
      this.products = C.groupArtworks(this.$$('[data-statement-product]').map(el => JSON.parse(el.textContent)).map(p => ({ ...p, variants: p.variants.filter(C.eligible) })).filter(p => p.variants.length));
      this.canvas = this.$('canvas');
      this.shopCanvas=document.createElement('canvas');this.shopCanvas.className='statement-shop-canvas';this.shopCanvas.setAttribute('role','img');this.shopCanvas.setAttribute('aria-label','Styled room mockup of the selected artwork');this.$('.statement-room-view').append(this.shopCanvas);
      this.ctx = this.canvas.getContext('2d');
      if (!this.ctx || !window.PointerEvent || !this.products.length) {
        this.$('[data-empty]').hidden = false;
        this.$('[data-empty]').textContent = this.t[this.products.length ? 'unsupported' : 'empty'];
        return;
      }
      this.$('[data-studio]').hidden = false;
      this.cache = new Map();
      this.positions = new Map();
      this.s = { x: .5, y: .28, width: .24, rotation: 0, cropZoom: 1, cropX: .5, cropY: .5, color: this.dataset.defaultColor || '#e6dcc8', brush: 45, lighting: 'daylight', reference: 84, calibration: null };
      this.mask = makeCanvas(1440, 960);
      this.s.wallOn = false;
      this.s.wallRange = 32;
      this.layer = makeCanvas(1440, 960);
      this.mode = 'place';
      this.before = false;
      const roomOptions = [...this.control('room').options];
      if (roomOptions.some(o => o.dataset.src?.trim() === this.dataset.roomSrc.trim())) roomOptions[0].remove();
      this.buildRoomGallery();
      this.bind();
      const fitStudio = () => {
        const top = this.$('[data-studio]').getBoundingClientRect().top + window.scrollY;
        this.style.setProperty('--studio-height', `${Math.max(320, window.innerHeight - top - 16)}px`);
      };
      this.on(window, 'resize', fitStudio);
      this.layoutObserver = new ResizeObserver(fitStudio);
      this.layoutObserver.observe(document.body);
      this.previewObserver=new ResizeObserver(()=>this.draw());this.previewObserver.observe(this.$('.statement-gallery'));
      fitStudio();
      this.control('artwork').replaceChildren(...this.products.map(p => new Option(p.title, String(p.id))));
      this.selectProduct(this.products.find(p => p.variants.some(v => v.image && v.available)) || this.products[0]);
      this.curateRooms(true);
      this.buildArtworkChoices();

    }
    disconnectedCallback() {
      clearTimeout(this.previewFormTimer);
      this.abort?.abort();
      this.layoutObserver?.disconnect();
      this.previewObserver?.disconnect();
      this.roomToken = Symbol();
      this.artToken = Symbol();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    on(el, event, callback) { el.addEventListener(event, callback, { signal: this.abort.signal }); }
    status(key) { this.$('[data-status]').textContent = this.t[key] || key; this.$('[data-editor-status]').textContent = this.t[key] || key; }
    control(name) { return this.$(`[data-control="${name}"]`); }
    bind() {
      this.on(this, 'click', event => {
        const target = event.target.closest('button,[data-choose-product],[data-space]');
        if (!target) return;
        if (target.dataset.view) this.galleryView(target.dataset.view);
        if (target.dataset.roomChoice) { this.control('room').value = target.dataset.roomChoice; this.change('room'); this.galleryView('room'); }
        if (target.dataset.tab) this.tab(target.dataset.tab);
        if (target.dataset.action) this.action(target.dataset.action);
        if (target.dataset.sizeChoice) this.change('size', target.dataset.sizeChoice);
        if (target.dataset.finishChoice) this.change('finish', target.dataset.finishChoice);
        if (target.dataset.chooseProduct) {
          const product = this.products.find(p => p.sourceProductIds.some(id => String(id) === target.dataset.chooseProduct));
          if (product) { this.selectProduct(product); this.curateRooms(true); this.$('[data-art-picker]').open = false; this.tab('place'); }
        }
        if (target.dataset.space) {
          const option = [...this.control('room').options].find(o => o.value === target.dataset.space);
          if (option) { this.control('room').value = option.value; this.loadRoom(option.dataset.src, option.textContent); }
          else this.status('space_help');
          this.tab('space');
        }
        if (target.dataset.color) this.change('color', target.dataset.color);
      });
      this.$$('[data-control]').forEach(el => this.on(el, el.tagName === 'SELECT' ? 'change' : 'input', () => this.change(el.dataset.control, el.value)));
      this.on(this.$('dialog'), 'click', event => { if (event.target === this.$('dialog')) this.$('dialog').close(); });
      this.on(this.$('.statement-editor-dialog'), 'close', () => this.closeEditor());
      const previewDialog=this.$('.statement-preview-dialog');
      this.on(previewDialog,'click',event=>{if(event.target===previewDialog)previewDialog.close();});
      this.on(previewDialog,'close',()=>{clearTimeout(this.previewFormTimer);this.$('[data-action="request-preview"]').focus({preventScroll:true});});
      this.on(this.$('[data-room-upload]'), 'change', async event => {
        const file = event.target.files[0]; if (!file) return;
        if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 20*1024*1024) { this.status('photo_error'); return; }
        const url = URL.createObjectURL(file);
        try { if (await this.loadRoom(url, this.t.your_room)) { this.control('room').selectedIndex = -1; this.syncRoomGallery(); this.control('reference').value = this.s.reference; this.status('calibrate_copy'); } }
        finally { URL.revokeObjectURL(url); event.target.value = ''; }
      });
      this.on(this.canvas, 'pointerdown', event => this.down(event));
      this.on(this.canvas, 'pointermove', event => this.move(event));
      const up = () => { this.drag = null; this.draw(); };
      this.on(this.canvas, 'pointerup', up); this.on(this.canvas, 'pointercancel', up); this.on(this.canvas, 'lostpointercapture', up);
      this.on(this.canvas, 'keydown', event => {
        if (!this.$('.statement-editor-dialog').open) return;
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Escape', 'Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Escape') { this.setMode('place'); return; }
        if (this.before) this.action('before');
        const step = event.shiftKey ? .025 : .005;
        if (['paint', 'erase', 'measure', 'wall'].includes(this.mode)) {
          this.brushPoint ||= { x: .25, y: .25 };
          if (event.key.startsWith('Arrow')) {
            const axis = /Left|Right/.test(event.key) ? 'x' : 'y';
            this.brushPoint[axis] = C.clamp(this.brushPoint[axis] + (/Left|Up/.test(event.key) ? -step : step), 0, 1);
          }
          if (event.key === 'Enter' || event.key === ' ') {
            const point = { x: this.brushPoint.x * this.canvas.width, y: this.brushPoint.y * this.canvas.height };
            if (this.mode === 'measure') this.measurePoint(point); else if (this.mode === 'wall') this.selectWall(point); else this.paint(point, point);
          }
          this.draw(); return;
        }
        if (this.mode === 'crop' && event.key.startsWith('Arrow')) {
          const axis = /Left|Right/.test(event.key) ? 'cropX' : 'cropY';
          this.updateView({[axis]: C.clamp(this.s[axis] + (/Left|Up/.test(event.key) ? -step : step), 0, 1)});
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') return;
        if (event.key.startsWith('Arrow')) {
          const axis = /Left|Right/.test(event.key) ? 'x' : 'y';
          this.s[axis] += /Left|Up/.test(event.key) ? -step : step;
        }
        this.draw();
      });
    }
    tab() { this.setMode('place'); }
    buildArtworkChoices() {
      this.$('[data-artwork-choices]').replaceChildren(...this.products.map(product => {
        const button = document.createElement('button'), img = document.createElement('img'), label = document.createElement('span');
        button.type = 'button'; button.dataset.chooseProduct = product.id;
        button.setAttribute('aria-pressed', String(product.id === this.product.id));
        const source = product.variants.find(v => v.image); img.src = source?.image || ''; img.alt = ''; img.loading = 'lazy'; img.width = img.height = 100;
        label.textContent = product.title; button.append(img,label); return button;
      }));
    }
    visualOptions() {
      const sizes = [...new Set(this.product.variants.map(v => v.size))];
      const sizeButtons = () => sizes.map(size => {
        const button = document.createElement('button'); button.type='button'; button.dataset.sizeChoice=size;
        button.textContent=size.replace(/\s*[xX×]\s*/,' × '); button.setAttribute('aria-pressed',String(size===this.variant.size)); return button;
      });
      this.$('[data-size-buttons]').replaceChildren(...sizeButtons()); this.$('[data-editor-sizes]').replaceChildren(...sizeButtons());
      const finishes=this.product.variants.filter(v=>v.size===this.variant.size);
      this.$('[data-frame-buttons]').replaceChildren(...finishes.map(v=>{
        const button=document.createElement('button'),img=document.createElement('img');button.type='button';button.dataset.finishChoice=v.finish;
        button.title=v.finish;button.setAttribute('aria-label',v.finish);button.setAttribute('aria-pressed',String(v.id===this.variant.id));
        if(v.image){img.src=v.image;img.alt='';img.width=img.height=60;img.loading='lazy';button.append(img);}else button.textContent=v.finish;
        return button;
      }));
      this.$('[data-finish-name]').textContent=this.variant.finish;
      this.$$('[data-choose-product]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.chooseProduct===String(this.product.id))));
    }
    curateRooms(load=false) {
      const horizontal=C.orientation(this.variant)==='horizontal';
      const values=horizontal?['room_0','room_4','alcove']:['alcove','room_6','room_0'];
      this.$$('[data-room-choice]').forEach(b=>b.hidden=!values.includes(b.dataset.roomChoice));
      if(load){const option=[...this.control('room').options].find(o=>o.value===values[0]);if(option){this.control('room').value=option.value;this.loadRoom(option.dataset.src,option.textContent);}}
    }
    closeEditor() {
      this.$('.statement-room-view').append(this.$('.statement-stage'));
      this.$('.statement-workspace').append(this.$('[data-instruction]'),this.$('[data-scale-note]'));
      this.setMode('place'); this.dataset.editing='false'; this.canvas.tabIndex=-1;
      this.updateComparisons();
    }
    galleryView(view) {
      this.$('[data-gallery-view]').dataset.galleryView = view;
      this.$$('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    }
    buildRoomGallery() {
      this.roomImages = new Map();
      const alcove=new Option(this.t.ai_room,'alcove');alcove.dataset.src=this.dataset.alcoveSrc;this.control('room').append(alcove);
      this.$('[data-room-thumbnails]').replaceChildren(...[...this.control('room').options].map(option => {
        const button = document.createElement('button'), img = document.createElement('img'), label = document.createElement('span');
        button.type = 'button'; button.dataset.roomChoice = option.value;
        button.setAttribute('aria-pressed', String(option.selected));
        img.alt = ''; img.width = img.height = 180;
        img.src = option.dataset.src || this.dataset.roomSrc;
        label.textContent = option.textContent;
        button.append(img, label); return button;
      }));
    }
    syncRoomGallery() {
      this.$$('[data-room-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.roomChoice === this.control('room').value)));
    }
    async updateRoomThumbnails() {
      const token = this.thumbnailToken = Symbol(), art = this.art, variant = this.variant;
      await Promise.all([...this.control('room').options].map(async option => {
        const src = option.dataset.src || this.dataset.roomSrc;
        try {
          if (!this.roomImages.has(src)) this.roomImages.set(src, image(src).catch(error => { this.roomImages.delete(src); throw error; }));
          const room = await this.roomImages.get(src);
          if (token !== this.thumbnailToken || !this.isConnected) return;
          const canvas = makeCanvas(180, 180), ctx = canvas.getContext('2d'), side = Math.min(room.width, room.height);
          ctx.drawImage(room, (room.width-side)/2, (room.height-side)/2, side, side, 0, 0, 180, 180);
          if (art) {
            let preset = src.match(/statement-room-(\w+)\.webp/)?.[1];
            if (preset === 'sofa') preset = 'living';
            const ref = C.sceneReferences[preset], size = C.dimensions(variant.size);
            const outer = C.dimensions(variant.finish), inches = outer?.width || size.width;
            const width = inches * room.width * (ref ? ref.fraction/ref.inches : 1/144) / side * 180;
            const height = width * art.height/art.width, centerY = preset === 'alcove' ? .39 : preset === 'living' ? .36 : preset === 'piano' ? .25 : .28;
            ctx.shadowColor = '#201b1840'; ctx.shadowBlur = 1.5; ctx.shadowOffsetY = 1;
            ctx.drawImage(art, (180-width)/2, centerY*180-height/2, width, height);
          }
          const button = this.$$('[data-room-choice]').find(b => b.dataset.roomChoice === option.value);
          button.querySelector('img').src = canvas.toDataURL('image/webp', .85);
          button.dataset.variant = String(variant.id);
        } catch { /* The room photograph remains available if its preview cannot load. */ }
      }));
    }
    async updateComparisons() {
      const token=this.comparisonToken=Symbol(),current=this.variant;
      const sizes=[...new Set(this.product.variants.map(v=>v.size))].filter(size=>C.orientation({size})===C.orientation(current));
      const chosen=sizes.length<=3?sizes:[sizes[0],sizes[Math.floor((sizes.length-1)/2)],sizes.at(-1)];
      const options=chosen.map(size=>this.product.variants.find(v=>v.size===size&&v.finish===current.finish&&v.image)||this.product.variants.find(v=>v.size===size&&v.image)).filter(Boolean);
      try {
        if(!this.comparisonRoom)this.comparisonRoom=await image(this.dataset.alcoveSrc);
        const room=this.comparisonRoom;
        const cards=await Promise.all(options.map(async variant=>{
          const art=await image(variant.image),c=makeCanvas(480,480),ctx=c.getContext('2d');
          const side=Math.min(room.width,room.height);ctx.drawImage(room,(room.width-side)/2,0,side,side,0,0,480,480);
          const d=C.dimensions(variant.finish)||C.dimensions(variant.size),width=d.width/144*room.width/side*480,height=width*art.height/art.width;
          ctx.shadowColor='#241d2240';ctx.shadowBlur=3;ctx.shadowOffsetY=2;ctx.drawImage(art,(480-width)/2,.39*480-height/2,width,height);
          const button=document.createElement('button'),img=document.createElement('img'),label=document.createElement('strong'),finish=document.createElement('span');button.type='button';button.dataset.sizeChoice=variant.size;button.setAttribute('aria-pressed',String(current.size===variant.size));
          img.src=c.toDataURL('image/webp',.88);img.alt=`${this.product.title}, ${variant.size}, ${variant.finish} — styled mockup`;img.width=img.height=480;
          label.textContent=variant.size.replace(/\s*[xX×]\s*/,' × ')+'″';finish.textContent=variant.finish;button.append(img,label,finish);return button;
        }));
        if(token!==this.comparisonToken)return;
        this.$('[data-size-comparisons]').replaceChildren(...cards);this.$('[data-comparison-reference]').textContent=this.t.comparison_note;
      } catch { /* The main preview remains usable when comparison media is unavailable. */ }
    }
    setMode(mode) {
      this.pinnedView = false;
      this.mode = this.mode === mode && ['paint','erase','crop'].includes(mode) ? 'place' : mode;
      this.measurePoints = [];
      this.$$('[data-action="paint"],[data-action="erase"],[data-action="wall"]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.action === this.mode)));
      this.$('[data-instruction]').textContent = this.t[`${this.mode}_help`] || this.t.drag_help;
      this.$('[data-editor-help]').textContent = this.t[`${this.mode}_help`] || this.t.drag_help;
      this.canvas.style.cursor = this.mode === 'place' ? 'grab' : 'crosshair';
      this.draw();
    }
    selectProduct(product) {
      if (this.product) this.positions.set(this.product.id, { x: this.s.x, y: this.s.y, width: this.s.width, variant: this.variant.id });
      this.product = product;
      const saved = this.positions.get(product.id);
      if (saved) Object.assign(this.s, { x: saved.x, y: saved.y, width: saved.width });
      const preferred=product.variants.find(v=>v.available&&v.image&&/natural wood float/i.test(v.finish)&&C.dimensions(v.size).width*C.dimensions(v.size).height===1728)||product.variants.find(v=>v.available&&v.image&&/natural wood float/i.test(v.finish)&&[1536,1600].includes(C.dimensions(v.size).width*C.dimensions(v.size).height));
      this.selectVariant(product.variants.find(v => v.id === saved?.variant) || preferred || product.variants.find(v => v.available && v.image) || product.variants[0]);
      this.control('artwork').value = String(product.id);
      const journey=product.title==='The Journey Home';
      this.$('[data-meaning]').textContent=this.t[journey?'journey_meaning':'default_meaning'];
      this.$('[data-mobile-title]').textContent=product.title;this.$('[data-mobile-meaning]').textContent=this.$('[data-meaning]').textContent;
      this.$('[data-story-title]').textContent=product.title;
      this.$('[data-story]').textContent=this.t[journey?'journey_story':'default_story'];
      this.$('[data-story-link]').href=product.url;
      const reviews=this.$('[data-reviews]');reviews.hidden=!(Number(product.rating)>0&&Number(product.reviewCount)>0);
      reviews.textContent=`★ ${Number(product.rating).toFixed(2)} / 5 · ${product.reviewCount || 0} artwork reviews`;reviews.href=product.url+'?view_options=1#judgeme_product_reviews';
    }
    selectVariant(variant) {
      this.variant = variant;
      this.pinnedView = false;
      const fill = (name, values, value) => { const el = this.control(name); el.replaceChildren(...[...new Set(values)].map(v => new Option(v, v))); el.value = value; };
      fill('size', this.product.variants.map(v => v.size), variant.size);
      fill('finish', this.product.variants.filter(v => v.size === variant.size).map(v => v.finish), variant.finish);
      this.$('[data-selection-title]').textContent = this.product.title;
      this.$('[data-selection-detail]').textContent = `${variant.size} · ${variant.finish}`;
      this.$('[data-price]').textContent = variant.money;
      this.$('[data-availability]').textContent = this.t[variant.available ? 'available' : 'sold_out'];
      this.$('[data-action="cart"]').disabled = this.cartBusy || !variant.available;
      this.$('[data-product-link]').href = `${variant.productUrl}?variant=${variant.id}`;
      this.$('[data-detail-finish]').textContent = variant.finish;
      this.visualOptions(); this.curateRooms();
      this.scaleFromReference();
      this.loadArt(variant);
    }
    async loadArt(variant) {
      const token = this.artToken = Symbol(); this.art = null; this.draw();
      this.$('[data-art-detail]').hidden = true;
      this.$('[data-detail-empty]').hidden = false;
      this.$('[data-detail-empty]').textContent = this.t.loading;
      this.$$('[data-action="enlarge"]').forEach(button => button.disabled = true);
      this.thumbnailToken = Symbol();
      if (!variant.image) { this.$('[data-detail-empty]').textContent = this.t.preview_unavailable; this.updateRoomThumbnails(); this.status('preview_unavailable'); return; }
      try {
        if (!this.cache.has(variant.image)) this.cache.set(variant.image, image(variant.image).catch(error => { this.cache.delete(variant.image); throw error; }));
        const loaded = await this.cache.get(variant.image);
        if (this.artToken !== token) return;
        this.art = loaded;
        const detail = this.$('[data-art-detail]'); detail.src = loaded.src; detail.alt = `${this.product.title} · ${variant.size} · ${variant.finish}`; detail.hidden = false;
        this.$('[data-detail-empty]').hidden = true;
        this.$$('[data-action="enlarge"]').forEach(button => button.disabled = false);
        this.updateRoomThumbnails();
        this.updateComparisons();
        while (this.cache.size > 8) this.cache.delete(this.cache.keys().next().value);
        this.draw();
      } catch { if (this.artToken === token) { this.$('[data-detail-empty]').textContent = this.t.image_error; this.updateRoomThumbnails(); this.status('image_error'); } }
    }
    async loadRoom(src, name) {
      const token = this.roomToken = Symbol(); this.status('loading');
      try {
        const img = await image(src);
        if (this.roomToken !== token) return false;
        if (img.naturalWidth * img.naturalHeight > 60000000) throw new Error('too_many_pixels');
        this.originalRoom = img; this.roomName = name;
        this.wallBase = null;
        this.wallSeed = null;
        this.wallPreset = src.match(/\/statement-room-(alcove|living|sofa|fireplace|entry|bedroom|dining|reflection|piano)\.webp(?:\?|$)/)?.[1] || null;
        if (this.wallPreset === 'sofa') this.wallPreset = 'living';
        Object.assign(this.s,{x:.5,y:.28});
        if (this.wallPreset === 'alcove') Object.assign(this.s,{x:.5,y:.39});
        if (this.wallPreset === 'living') Object.assign(this.s,{x:.5,y:.36});
        if (this.wallPreset === 'piano') Object.assign(this.s,{x:.5,y:.25});
        this.s.wallOn = false;
        Object.assign(this.s, { rotation: 0, cropZoom: 1, cropX: .5, cropY: .5, calibration: null });
        this.updateRoom(); this.originalRoom = this.room; this.setSceneScale(); this.clearMask(); this.syncControls();
        this.$('[data-room-name]').textContent = name;
        this.$('[data-scene-type]').textContent=this.wallPreset?this.t.styled_room:this.t.your_room;
        this.control('reference').value=this.s.reference;this.syncRoomGallery();
        this.status(''); return true;
      } catch (error) { if (token === this.roomToken) this.status(error.message === 'too_many_pixels' ? 'too_many_pixels' : 'room_error'); return false; }
    }
    updateRoom() {
      if (!this.originalRoom) return;
      const src = this.originalRoom, odd = this.s.rotation % 180 !== 0;
      const w = odd ? src.naturalHeight || src.height : src.naturalWidth || src.width;
      const h = odd ? src.naturalWidth || src.width : src.naturalHeight || src.height;
      const factor = Math.min(1, 1800 / Math.max(w, h));
      this.room = makeCanvas(Math.round(w * factor), Math.round(h * factor));
      const c = this.room.getContext('2d'); c.translate(this.room.width / 2, this.room.height / 2); c.rotate(this.s.rotation * Math.PI / 180);
      c.drawImage(src, -(src.naturalWidth || src.width) * factor / 2, -(src.naturalHeight || src.height) * factor / 2, (src.naturalWidth || src.width) * factor, (src.naturalHeight || src.height) * factor);
      this.sampleRoomLight();
      this.canvas.width = this.canvas.height = Math.min(this.room.width, this.room.height);
      this.mask.width = this.canvas.width; this.mask.height = this.canvas.height; this.layer.width = this.canvas.width; this.layer.height = this.canvas.height;
      if (this.s.wallOn) this.refreshWall();
      this.draw();
    }
    viewCrop() {
      const side = Math.min(this.room.width, this.room.height) / this.s.cropZoom;
      return {x:(this.room.width-side)*this.s.cropX,y:(this.room.height-side)*this.s.cropY,side};
    }
    updateView(patch) {
      if (!this.room) return;
      const before = this.viewCrop();
      Object.assign(this.s, patch);
      this.s.cropZoom = C.clamp(this.s.cropZoom, .65, 2.5);
      const after = this.viewCrop();
      const move = point => ({x:(before.x + point.x * before.side - after.x) / after.side,y:(before.y + point.y * before.side - after.y) / after.side});
      Object.assign(this.s, move(this.s));
      for (const position of this.positions.values()) Object.assign(position, move(position));
      this.measurePoints = null;
      this.before = false; this.pinnedView = false;
      this.$('[data-action="before"]')?.setAttribute('aria-pressed', 'false');
      this.refreshWall(); this.syncControls(); this.draw();
    }
    setSceneScale() {
      const ref = C.sceneReferences[this.wallPreset];
      this.s.reference = ref?.inches || 84;
      this.s.pixelsPerInch = ref ? this.originalRoom.width * ref.fraction / ref.inches : this.originalRoom.width / 144;
      this.s.scaleSource = ref ? this.wallPreset : 'estimate';
      this.s.calibration = null; this.s.measureSide = null;
      this.scaleFromReference();
    }
    clearMask() { this.mask.getContext('2d').clearRect(0, 0, this.mask.width, this.mask.height); this.s.wallOn = false; this.syncSwatches(); this.draw(); }
    syncSwatches() {
      this.$$('[data-color]').forEach(el => el.setAttribute('aria-pressed', String(this.s.wallOn && el.dataset.color === this.s.color)));
      this.control('color').value = this.s.color;
      this.$('[data-color-indicator]').style.background = this.s.wallOn ? this.s.color : '';
      this.$('[data-color-summary]').textContent = this.s.wallOn ? (this.$$('[data-color]').find(el => el.dataset.color === this.s.color)?.dataset.colorName || this.t.custom_color) : this.t.original_wall;
      const selected = this.$$('[data-color]').find(el => el.dataset.color === this.s.color);
      this.$('[data-selected-color-name]').textContent = selected ? selected.dataset.colorName : this.t.custom_color;
      this.$('[data-color-value]').textContent = this.s.color.toUpperCase();
      this.$('.statement-custom-color').style.setProperty('--selected-color', this.s.color);
    }
    orientedWall() {
      if (!this.wallBase) return null;
      const out = makeCanvas(this.room.width, this.room.height), c = out.getContext('2d');
      c.translate(out.width / 2, out.height / 2); c.rotate(this.s.rotation * Math.PI / 180);
      c.drawImage(this.wallBase, -this.wallBase.width / 2, -this.wallBase.height / 2);
      return out;
    }
    refreshWall() {
      if (!this.s.wallOn || !this.wallBase) { this.clearMask(); return; }
      const source = this.orientedWall(), c = this.mask.getContext('2d'), view = this.viewCrop();
      c.globalCompositeOperation = 'source-over'; c.clearRect(0, 0, this.mask.width, this.mask.height);
      c.drawImage(source, view.x, view.y, view.side, view.side, 0, 0, this.mask.width, this.mask.height);
      this.draw();
    }
    autoWall(force = false) {
      if (!this.room) return;
      const refresh = !this.wallBase || force || !this.s.wallOn;
      if (!this.wallBase || force) {
        const result = window.StatementWalls.create(this.originalRoom, this.wallPreset, this.wallSeed, this.s.wallRange);
        this.wallBase = result.canvas;
        this.wallFound = result.found;
      }
      this.s.wallOn = this.wallFound;
      if (refresh) this.refreshWall(); this.syncSwatches(); this.draw();
      this.status(this.wallFound ? (this.wallPreset && !this.wallSeed ? 'wall_ready' : 'wall_estimated') : 'wall_not_found');
    }
    selectWall(point) {
      const view = this.viewCrop();
      const rx = (view.x + point.x / this.canvas.width * view.side) / this.room.width;
      const ry = (view.y + point.y / this.canvas.height * view.side) / this.room.height;
      this.wallSeed = this.s.rotation === 90 ? {x:ry,y:1-rx} : this.s.rotation === 180 ? {x:1-rx,y:1-ry} : this.s.rotation === 270 ? {x:1-ry,y:rx} : {x:rx,y:ry};
      this.autoWall(true); this.setMode('place');
    }
    async applyWallMask(maskBlob) {
      if (!(maskBlob instanceof Blob) || !this.room) throw new Error('A local image mask and room are required.');
      const url = URL.createObjectURL(maskBlob);
      try {
        const mask = await image(url);
        if (mask.width !== this.canvas.width || mask.height !== this.canvas.height) throw new Error('Mask dimensions must match the current room canvas.');
        this.clearMask(); this.mask.getContext('2d').drawImage(mask, 0, 0); this.s.wallOn = true; this.wallBase = null; this.draw();
      } finally { URL.revokeObjectURL(url); }
    }
    change(name, value) {
      if (name === 'artwork') { const product = this.products.find(p => String(p.id) === value); if (product) this.selectProduct(product); return; }
      if (name === 'cropZoom') { this.updateView({cropZoom:Number(value)}); return; }
      if (name === 'room') { const opt = this.control('room').selectedOptions[0]; this.loadRoom(opt.dataset.src || this.dataset.roomSrc, opt.textContent); return; }
      if (name === 'size' || name === 'finish') {
        const next = this.product.variants.find(v => v.size === (name === 'size' ? value : this.variant.size) && v.finish === (name === 'finish' ? value : this.variant.finish)) || this.product.variants.find(v => v.size === value);
        if (next) this.selectVariant(next); return;
      }
      if (['color','lighting'].includes(name)) this.s[name] = value;

      else if (['x','y'].includes(name)) this.s[name] = Number(value) / 100;
      else this.s[name] = Number(value);
      if (name === 'color') { this.autoWall(); this.setMode('place'); }
      if (name === 'wallRange') this.autoWall(true);
      if (name === 'reference') this.scaleFromReference();
      this.before = false; this.$('[data-action="before"]')?.setAttribute('aria-pressed', 'false');
      this.pinnedView = false;
      this.draw();
    }
    scaleFromReference() {
      if (!this.variant || !this.room) return;
      const preset = C.sceneReferences[this.s.scaleSource];
      if (preset && !this.s.calibration) {
        this.s.reference = preset.inches;
        this.s.pixelsPerInch = Math.max(this.room.width,this.room.height) * preset.fraction / preset.inches;
      }
      if (this.s.calibration && this.s.measureSide && Number.isFinite(this.s.reference) && this.s.reference > 0) {
        this.s.pixelsPerInch = this.s.calibration * this.s.measureSide / this.s.reference;
      }
      const d = C.dimensions(this.variant.size);
      const outer = this.variant.finish.match(/(\d+(?:\.\d+)?(?:\s+\d+\/\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?(?:\s+\d+\/\d+)?)/i);
      this.s.width = (outer ? C.dimensions(outer[0]).width : d.width) * (this.s.pixelsPerInch || this.room.width / 144) / this.viewCrop().side;
    }
    rect() {
      this.scaleFromReference();
      const d = C.dimensions(this.variant?.size);
      const ratio = this.art ? this.art.width / this.art.height : d ? d.width / d.height : 1;
      const r = {x:this.s.x,y:this.s.y,width:this.s.width,height:this.s.width / ratio};
      return {x:(r.x-r.width/2)*this.canvas.width,y:(r.y-r.height/2)*this.canvas.height,w:r.width*this.canvas.width,h:r.height*this.canvas.height};
    }
    point(event) { const r = this.canvas.getBoundingClientRect(); return { x: (event.clientX - r.left) * this.canvas.width / r.width, y: (event.clientY - r.top) * this.canvas.height / r.height }; }
    down(event) {
      if (!this.room || this.pinnedView || !this.$('.statement-editor-dialog').open) return;
      event.preventDefault(); this.canvas.focus({ preventScroll: true }); this.canvas.setPointerCapture(event.pointerId);
      if (this.before) this.action('before');
      const p = this.point(event), r = this.rect();
      if (this.mode === 'wall') { this.selectWall(p); return; }
      if (this.mode === 'measure') {
        this.measurePoint(p); return;
      }
      if (['paint','erase'].includes(this.mode)) { this.drag = { type: this.mode, last: p }; this.paint(p, p); return; }
      if (this.mode === 'crop') { this.drag = { type: 'crop', p, x: this.s.cropX, y: this.s.cropY }; return; }
      if (p.x >= r.x && p.x <= r.x + r.w && p.y >= r.y && p.y <= r.y + r.h) this.drag = { type: 'art', p, x: this.s.x, y: this.s.y };
    }
    move(event) {
      if (!this.drag) return;
      const p = this.point(event), d = this.drag;
      if (['paint','erase'].includes(d.type)) { this.paint(d.last, p); d.last = p; return; }
      if (d.type === 'art') { this.s.x = d.x + (p.x - d.p.x) / this.canvas.width; this.s.y = d.y + (p.y - d.p.y) / this.canvas.height; }
      if (d.type === 'crop') { this.updateView({cropX:C.clamp(d.x - (p.x - d.p.x) / this.canvas.width, 0, 1),cropY:C.clamp(d.y - (p.y - d.p.y) / this.canvas.height, 0, 1)}); }
      this.draw();
    }
    paint(a, b) {
      this.s.wallOn = true; this.syncSwatches();
      const c = this.mask.getContext('2d'); c.globalCompositeOperation = this.mode === 'erase' ? 'destination-out' : 'source-over';
      c.lineWidth = this.s.brush * this.canvas.width / 900; c.lineCap = 'round'; c.strokeStyle = '#fff'; c.beginPath(); c.moveTo(a.x, a.y); c.lineTo(b.x + .01, b.y + .01); c.stroke(); this.draw();
    }
    measurePoint(point) {
      this.measurePoints.push(point);
      if (this.measurePoints.length === 2) {
        const [a, b] = this.measurePoints;
        const distance = Math.hypot(a.x - b.x, a.y - b.y) / this.canvas.width;
        if (distance < .03 || !Number.isFinite(this.s.reference) || this.s.reference <= 0) { this.status('measure_error'); this.measurePoints = []; }
        else { this.s.calibration = distance; this.s.measureSide = this.viewCrop().side; this.s.scaleSource = 'measured'; this.scaleFromReference(); this.setMode('place'); this.status('measured'); }
      }
      this.draw();
    }
    syncControls() {
     
      ['color','lighting','cropZoom','brush'].forEach(key => { this.control(key).value = this.s[key]; });
      this.control('wallRange').value = this.s.wallRange;
      this.$('[data-zoom-value]').textContent = `${Math.round(this.s.cropZoom * 100)}%`;
      this.$('[data-action="zoom-out"]').disabled = this.s.cropZoom <= .65;
      this.$('[data-action="zoom-in"]').disabled = this.s.cropZoom >= 2.5;
      this.syncSwatches();
    }
    draw() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => {this.render(this.ctx, false);this.renderShop();}); }
    renderShop() {
      if(!this.room||!this.shopCanvas)return;
      const box=this.$('.statement-gallery').getBoundingClientRect();if(!box.width||!box.height)return;
      const out=this.shopCanvas,w=Math.round(box.width*1.5),h=Math.round(box.height*1.5);if(out.width!==w||out.height!==h){out.width=w;out.height=h;}
      const ctx=out.getContext('2d'),view=this.viewCrop();
      let factor=Math.min(w/this.room.width,h/this.room.height),offsetX=(w-this.room.width*factor)/2,offsetY=(h-this.room.height*factor)/2;
      if(window.matchMedia('(max-width: 749px)').matches){
        this.scaleFromReference();
        // Keep a consistent physical camera span across sizes; zoom the room
        // and artwork together, rather than enlarging the artwork independently.
        const sizes=this.product.variants.map(v=>C.dimensions(v.size)).filter(Boolean);
        const span=Math.max(64,...sizes.map(d=>d.width+16),...sizes.map(d=>(d.height+16)*w/h));
        factor=Math.max(w/this.room.width,h/this.room.height,w/((this.s.pixelsPerInch||this.room.width/144)*span));
        const focusX=view.x+this.s.x*view.side,focusY=view.y+this.s.y*view.side;
        offsetX=C.clamp(w*.5-focusX*factor,w-this.room.width*factor,0);
        offsetY=C.clamp(h*.43-focusY*factor,h-this.room.height*factor,0);
      }
      ctx.clearRect(0,0,w,h);ctx.fillStyle='#eeeadf';ctx.fillRect(0,0,w,h);ctx.drawImage(this.room,offsetX,offsetY,this.room.width*factor,this.room.height*factor);
      if(this.s.wallOn){ctx.save();ctx.globalAlpha=.95;ctx.drawImage(this.layer,offsetX+view.x*factor,offsetY+view.y*factor,view.side*factor,view.side*factor);ctx.restore();}
      if(this.art){const r=this.rect(),x=offsetX+(view.x+r.x/this.canvas.width*view.side)*factor,y=offsetY+(view.y+r.y/this.canvas.height*view.side)*factor;
        ctx.save();ctx.shadowColor='#20190f40';ctx.shadowBlur=4*factor;ctx.shadowOffsetY=2*factor;ctx.drawImage(this.artworkSurface(),x,y,r.w/this.canvas.width*view.side*factor,r.h/this.canvas.height*view.side*factor);ctx.restore();}
      if(this.s.lighting!=='daylight'){ctx.fillStyle=this.s.lighting==='evening'?'#b56c2420':'#2d34451c';ctx.fillRect(0,0,w,h);}
      out.setAttribute('aria-label',`${this.product.title}, ${this.variant.size}, ${this.variant.finish} — ${this.wallPreset?this.t.styled_room:this.t.your_room}`);
    }
    sampleRoomLight() {
      const small = makeCanvas(24,24), c = small.getContext('2d',{willReadFrequently:true});
      c.drawImage(this.room,0,0,24,24);
      const data = c.getImageData(0,0,24,24).data, rgb = [0,0,0], sides = [0,0], counts = [0,0];
      for (let y=2;y<10;y++) for (let x=4;x<20;x++) {
        const i=(y*24+x)*4, l=(data[i]+data[i+1]+data[i+2])/3;
        if (l<65) continue;
        const side=x<12?0:1; sides[side]+=l; counts[side]++;
        for (let k=0;k<3;k++) rgb[k]+=data[i+k];
      }
      const max=Math.max(...rgb,1), left=sides[0]/(counts[0]||1), right=sides[1]/(counts[1]||1);
      this.roomLight={color:`rgb(${rgb.map(v=>Math.round(C.clamp(v/max*255,205,255))).join(',')})`,direction:left>=right?1:-1};
      this.artSurface=null;
    }
    artworkSurface() {
      const light=this.roomLight||{color:'rgb(255,250,241)',direction:1};
      const key=[this.art.src,light.color,light.direction,this.s.wallOn,this.s.color].join('|');
      if (this.artSurface?.key===key) return this.artSurface.canvas;
      const factor=Math.min(1,1800/Math.max(this.art.width,this.art.height));
      const surface=makeCanvas(Math.round(this.art.width*factor),Math.round(this.art.height*factor)), c=surface.getContext('2d');
      c.drawImage(this.art,0,0,surface.width,surface.height);
      c.globalCompositeOperation='multiply';c.globalAlpha=.09;c.fillStyle=light.color;c.fillRect(0,0,surface.width,surface.height);
      c.globalCompositeOperation='source-atop';
      if(this.s.wallOn){c.globalAlpha=.025;c.fillStyle=this.s.color;c.fillRect(0,0,surface.width,surface.height);}
      c.globalAlpha=1;
      const wash=c.createLinearGradient(light.direction>0?0:surface.width,0,light.direction>0?surface.width:0,surface.height*.4);
      wash.addColorStop(0,'rgba(255,250,239,.015)');wash.addColorStop(.45,'rgba(0,0,0,0)');wash.addColorStop(1,'rgba(28,23,18,.045)');
      c.fillStyle=wash;c.fillRect(0,0,surface.width,surface.height);
      c.globalCompositeOperation='destination-in';c.drawImage(this.art,0,0,surface.width,surface.height);
      this.artSurface={key,canvas:surface};return surface;
    }
    renderArtwork(ctx,r,view) {
      const w=this.canvas.width,h=this.canvas.height,unit=this.s.pixelsPerInch/view.side*w,direction=this.roomLight?.direction||1;
      ctx.save();ctx.beginPath();ctx.rect(-view.x/view.side*w,-view.y/view.side*h,this.room.width/view.side*w,this.room.height/view.side*h);ctx.clip();
      ctx.fillStyle='#302820';
      ctx.shadowColor='rgba(36,29,22,.20)';ctx.shadowBlur=unit*.65;ctx.shadowOffsetX=unit*.24*direction;ctx.shadowOffsetY=unit*.4;
      ctx.fillRect(r.x,r.y,r.w,r.h);
      ctx.shadowColor='rgba(30,25,20,.34)';ctx.shadowBlur=unit*.12;ctx.shadowOffsetX=unit*.07*direction;ctx.shadowOffsetY=unit*.1;
      ctx.fillRect(r.x,r.y,r.w,r.h);
      ctx.shadowColor='transparent';ctx.shadowBlur=0;ctx.shadowOffsetX=ctx.shadowOffsetY=0;
      ctx.drawImage(this.artworkSurface(),r.x,r.y,r.w,r.h);ctx.restore();
    }
    render(ctx, exporting) {
      const w = this.canvas.width, h = this.canvas.height; ctx.clearRect(0,0,w,h);
      if (!this.room) { ctx.fillStyle = '#e8e3d8'; ctx.fillRect(0,0,w,h); return; }
      const view = this.viewCrop();
      ctx.fillStyle = '#e8e3d8'; ctx.fillRect(0,0,w,h);
      ctx.drawImage(this.room,view.x,view.y,view.side,view.side,0,0,w,h);
      if (this.before) return;
      const layer = this.layer.getContext('2d'); layer.clearRect(0,0,w,h); layer.globalCompositeOperation = 'source-over'; layer.drawImage(this.mask,0,0); layer.globalCompositeOperation = 'source-in'; layer.fillStyle = this.s.color; layer.fillRect(0,0,w,h);
      ctx.save(); ctx.globalAlpha = .95; ctx.globalCompositeOperation = 'source-over'; ctx.drawImage(this.layer,0,0); ctx.restore();
      const r = this.rect();
      if (this.art) {
        this.renderArtwork(ctx,r,view);
      }
      if (this.s.lighting !== 'daylight') { ctx.save(); ctx.fillStyle = this.s.lighting === 'evening' ? '#b56c2420' : '#2d34451c'; ctx.fillRect(0,0,w,h); ctx.restore(); }
      if (!exporting && this.art && this.mode === 'place' && this.drag?.type === 'art') {
        ctx.save(); ctx.beginPath(); ctx.rect(-view.x/view.side*w,-view.y/view.side*h,this.room.width/view.side*w,this.room.height/view.side*h); ctx.clip(); ctx.strokeStyle = '#ffffffaa'; ctx.lineWidth = 1; ctx.strokeRect(r.x,r.y,r.w,r.h); ctx.restore();
      }
      if (!exporting && this.measurePoints?.length) { const p=this.measurePoints[0]; ctx.fillStyle='#fff';ctx.beginPath();ctx.arc(p.x,p.y,7,0,Math.PI*2);ctx.fill(); }
      if (!exporting && this.brushPoint && ['paint','erase','measure','wall'].includes(this.mode)) { ctx.save();ctx.strokeStyle='#fff';ctx.lineWidth=3;ctx.beginPath();ctx.arc(this.brushPoint.x*w,this.brushPoint.y*h,this.s.brush*w/1800,0,Math.PI*2);ctx.stroke();ctx.restore(); }
      this.$('[data-scale-note]').textContent = this.s.scaleSource === 'measured' ? this.t.calibrated : this.t['scale_' + this.s.scaleSource] || this.t.approximate;
      this.$('[data-editor-scale]').textContent=this.$('[data-scale-note]').textContent;
      this.$('[data-dimension-label]').textContent = this.variant ? this.variant.size + '″ · ' + this.t.size_locked : '';
    }
    async action(name) {
      if(name==='request-preview'){
        const values={artwork:this.product.title,size:this.variant.size+' inches',finish:this.variant.finish,url:new URL(this.variant.productUrl||this.product.url,location.origin).href.split('?')[0]+'?variant='+this.variant.id};
        this.$('[data-preview-selection]').textContent=`${values.artwork} · ${values.size} · ${values.finish}`;
        const preview=this.$('[data-preview-art]');preview.hidden=!this.art;if(this.art){preview.src=this.art.src;preview.alt=values.artwork;}
        this.$('.statement-preview-dialog').showModal();
        clearTimeout(this.previewFormTimer);
        const deadline=Date.now()+30000,status=this.$('[data-preview-load-status]'),loading=this.$('[data-preview-loading]'),unavailable=this.$('[data-preview-unavailable]');
        status.hidden=false;loading.hidden=false;unavailable.hidden=true;
        const checkForm=()=>{
          if(this.$('[data-preview-app] shopify-forms-embed')?.getBoundingClientRect().height>100){status.hidden=true;return;}
          if(Date.now()>=deadline){loading.hidden=true;unavailable.hidden=false;}
          this.previewFormTimer=setTimeout(checkForm,500);
        };
        checkForm();return;
      }
      if(name==='close-preview'){this.$('.statement-preview-dialog').close();return;}
      if(name==='browse-art'){this.$('[data-art-picker]').open=true;this.$('[data-art-picker]').scrollIntoView({block:'center',behavior:'smooth'});return;}
      if(name==='compare-sizes'){this.$('[data-comparison-section]').scrollIntoView({block:'start',behavior:'smooth'});return;}
      if(name==='open-editor'){
        this.galleryView('room');this.$('[data-editor-stage]').append(this.$('.statement-stage'));
        this.$('.statement-editor-dialog').showModal();this.dataset.editing='true';this.canvas.tabIndex=0;this.syncControls();return;
      }
      if(name==='close-editor'){this.$('.statement-editor-dialog').close();return;}
      if (name === 'enlarge' && this.art) {
        const img = this.$('[data-art-large]'); img.src = this.art.src; img.alt = this.$('[data-art-detail]').alt;
        this.$('[data-dialog-title]').textContent = `${this.product.title} · ${this.variant.size} · ${this.variant.finish}`;
        this.$('.statement-art-dialog').showModal(); return;
      }
      if (name === 'close-detail') { this.$('.statement-art-dialog').close(); return; }
      if (name === 'cart') { await this.addToCart(); return; }
      if (name === 'before') { this.pinnedView=false; this.before=!this.before; this.$('[data-action="before"]')?.setAttribute('aria-pressed',String(this.before)); this.draw(); return; }
      if (['paint','erase','crop','measure','wall'].includes(name)) { this.before=false; this.$('[data-action="before"]')?.setAttribute('aria-pressed','false'); this.setMode(name); return; }
      if (name === 'auto-wall') { this.wallSeed = null; this.before = false; this.pinnedView = false; this.$('[data-action="before"]')?.setAttribute('aria-pressed','false'); this.autoWall(true); this.setMode('place'); }
      if (name === 'clear-mask') this.clearMask();
      if (name === 'clear-measure') { this.setSceneScale(); this.syncControls(); }
      if (name === 'rotate') { this.s.rotation=(this.s.rotation+90)%360; this.updateRoom(); }
      if (name === 'zoom-out' || name === 'zoom-in') this.updateView({cropZoom:this.s.cropZoom + (name === 'zoom-in' ? .1 : -.1)});
      if (name === 'uncrop') this.updateView({cropZoom:1,cropX:.5,cropY:.5});
      if (name === 'reset') {
        this.positions.clear();
        this.before=false; this.pinnedView=false;this.pinned=null;this.setMode('place');
        Object.assign(this.s,{x:.5,y:.28,width:.24,color:this.dataset.defaultColor,lighting:'daylight'});
        await this.loadRoom(this.dataset.roomSrc,this.t.sample_living);this.control('room').selectedIndex=0;this.syncRoomGallery();
        this.deleteSaved();
      }
      if (name === 'download') await this.download();
      if (name === 'save') await this.save();
      if (name === 'restore') await this.restore();
      this.draw();
    }
    async download() {
      if(!this.room || !this.art){this.status('preview_unavailable');return;}
      try {
        const out=makeCanvas(this.canvas.width,this.canvas.height+84),c=out.getContext('2d');this.render(c,true);c.fillStyle='#f5f2eb';c.fillRect(0,this.canvas.height,out.width,84);c.fillStyle='#343831';c.font=`${Math.max(14,out.width/70)}px Georgia`;c.fillText(this.pinnedView?this.pinned.title:`${this.product.title} · ${this.variant.size} · ${this.variant.finish}`,20,this.canvas.height+30,out.width-40);c.font=`${Math.max(11,out.width/100)}px Arial`;c.fillText(this.t.export_note,20,this.canvas.height+59,out.width-40);
        const data=await blob(out),url=URL.createObjectURL(data),a=document.createElement('a');a.href=url;a.download='gabriel-heaton-room-preview.png';a.click();setTimeout(()=>URL.revokeObjectURL(url),10000);this.status('downloaded');
      } catch {this.status('export_error');}
    }
    async database() {
      return new Promise((resolve,reject)=>{const request=indexedDB.open('gha-statement-design',1);request.onupgradeneeded=()=>request.result.createObjectStore('design');request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);});
    }
    async dbOperation(mode, fn) {
      const db=await this.database();try{return await new Promise((resolve,reject)=>{const tx=db.transaction('design',mode);const request=fn(tx.objectStore('design'));tx.oncomplete=()=>resolve(request.result);tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);});}finally{db.close();}
    }
    async save() {
      if(!this.room){this.status('room_error');return;}
      try { const value={version:4,roomName:this.roomName,roomOption:this.control('room').value,state:{...this.s,rotation:0},product:this.product.id,variant:this.variant.id,room:await blob(this.room),mask:await blob(this.mask),wallBase:this.wallBase?await blob(this.orientedWall()):null,wallPreset:this.wallPreset};await this.dbOperation('readwrite',store=>store.put(value,'current'));this.status('saved'); } catch {this.status('save_error');}
    }
    async deleteSaved(){try{await this.dbOperation('readwrite',store=>store.delete('current'));}catch{this.status('delete_error');}}
    async restore() {
      try {
        const value=await this.dbOperation('readonly',store=>store.get('current'));if(!value){this.status('no_saved');return;}if(value.version!==4){this.status('saved_legacy');return;}
        const product=this.products.find(p=>p.variants.some(v=>v.id===value.variant)),variant=product?.variants.find(v=>v.id===value.variant);if(!variant){this.status('saved_unavailable');return;}
        const url=URL.createObjectURL(value.room),maskURL=URL.createObjectURL(value.mask);
        try { if(!await this.loadRoom(url,value.roomName)) return;Object.assign(this.s,value.state);this.selectProduct(product);Object.assign(this.s,value.state);this.selectVariant(variant);const mask=await image(maskURL);this.mask.getContext('2d').drawImage(mask,0,0,this.mask.width,this.mask.height);if(value.wallBase){const wallURL=URL.createObjectURL(value.wallBase);try{const wallImage=await image(wallURL);this.wallBase=makeCanvas(this.room.width,this.room.height);this.wallBase.getContext('2d').drawImage(wallImage,0,0);this.wallFound=true;}finally{URL.revokeObjectURL(wallURL);}}this.wallPreset=value.wallPreset;this.control('room').value=value.roomOption;this.syncRoomGallery();this.syncControls();this.status('restored');this.draw(); } finally {URL.revokeObjectURL(url);URL.revokeObjectURL(maskURL);}
      }catch{this.status('save_error');}
    }
    async addToCart() {
      if(this.cartBusy || !this.variant?.available)return;
      if(this.pinnedView){this.status('pinned_purchase');return;}
      const product=this.product,variant=this.variant,button=this.$('[data-action="cart"]');this.cartBusy=true;button.disabled=true;this.status('checking');
      try {
        const response=await fetch(`${variant.productUrl}.js`,{headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('catalog_error');
        const fresh=await response.json().catch(()=>{throw new Error('catalog_error');}),current=fresh.variants.find(v=>v.id===variant.id);
        if(!current || !current.available){variant.available=false;if(this.variant.id===variant.id)this.selectVariant(variant);throw new Error('unavailable');}
        if(current.price!==variant.price){variant.price=current.price;variant.money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format(current.price/100);if(this.variant.id===variant.id)this.selectVariant(variant);throw new Error('price_changed');}
        const root=window.Shopify?.routes?.root||this.dataset.root||'/',result=await fetch(`${root.replace(/\/?$/,'/')}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(C.cartBody(variant.id,window.location.pathname)),signal:AbortSignal.timeout(15000)});
        const data=await result.json().catch(()=>{throw new Error('cart_error');});if(!result.ok || data.status)throw new Error(data.description||'cart_error');
        this.$('[data-cart-link]').hidden=false;
        if(document.getElementById('Cart-Drawer')) {document.dispatchEvent(new CustomEvent('cart:refresh'));document.getElementById('cart-drawer-toggle')?.click();}
        this.status(`${product.title} · ${variant.size} · ${variant.finish} — ${this.t.added}`);
      }catch(error){const uncertain=error.name==='TimeoutError'||error.name==='AbortError'||error.message==='Failed to fetch';this.status(uncertain?'network_error':error.message);if(uncertain)this.$('[data-cart-link]').hidden=false;}
      finally{this.cartBusy=false;button.disabled=!this.variant.available;}
    }
  }
  customElements.define('statement-collection',StatementCollection);
})();
